import React, { useCallback, useEffect, useState, useRef } from "react";
import { Button, Tabs, message, Form, Input, Upload, Modal, Select } from "antd";
import type { RcFile, UploadFile, UploadProps } from "antd/es/upload/interface";
import type { UploadChangeParam } from "antd/es/upload";
import type { TabsProps } from "antd";
import { Link } from "react-router-dom";
import {
  LoadingOutlined,
  PlusSquareFilled,
  CloseCircleFilled,
  CheckCircleFilled,
  ReloadOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { cloneDeep, delay } from "lodash-es";
import _, { debounce } from "lodash";
import { useSelector } from "react-redux";
import StickyBox from "react-sticky-box";
import { iframeUtils } from "@kaihong/utils/lib/iframePostMessage";
import api from "@/api";
import { format, findDeep, changeSize, getRulesDetail, resetFormValidate, validateFormField, goLogin } from "@/utils";
import { appNameReg } from "@/utils/constant";
import { uploadBaseUrl } from "@/api/release";
import { publicPath } from "@/utils/base";
import ApplyDown from "./ApplyDown";

import dataJson from "@/../public/data.json";

const prefix = "relue_version_manage";
import "./index.less";
import { getAuthTokenValue } from "@kaihong/utils/lib/khAuthToken";

const VersionManage: React.FC = () => {
  const { id } = useParams();
  const {
    release,
    rules_list,
    please_enter,
    icon_text,
    one_bars,
    two_bars,
    please_upload,
    save_text,
    save_success_text,
    req_err,
    cancelText,
    confirmText,
    rules_detail,
    asterisk,
    name_label,
    description_label,
  } = dataJson;
  const [activeKey, setActiveKey] = useState("1");
  const [previewData, setPreviewData] = useState<any[]>([]);
  const [iconLoading, setIconLoading] = useState(false);
  const [iconImageUrl, setIconImageUrl] = useState<string>();
  const [previewLoading, setPreviewLoading] = useState(false);
  const detailData = useRef<any>();
  const baseFinishSeqRef = useRef(0);
  const [isBaseFinish, setIsBaseFinish] = useState(false);

  const [applyDownVisible, setApplyDownVisible] = useState(false);
  const [versionList, setVerSionList] = useState([{ createTime: "", version: "", id: "" }]);
  const [industryOption, setIndustryOption] = useState<any[]>([]);
  const [isLoadVersion, setIsLoadVersion] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const rulesDetail = useSelector((state: any) => state.rulesDetail);
  const [savaLoading, setSavaLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [cancelReleaseLoading, setCancelReleaseLoading] = useState(false);
  const [cancelDownLoading, setCancelDownLoading] = useState(false);

  const [baseForm] = Form.useForm();
  const baseFormValues = Form.useWatch([], baseForm);

  const [versionForm] = Form.useForm();
  const versionFormValues = Form.useWatch([], versionForm);

  const uploadUrl = `${uploadBaseUrl}/app/upload/public/${id}`;

  const updateBaseFinish = useCallback(() => {
    const seq = ++baseFinishSeqRef.current;
    baseForm
      .validateFields({ validateOnly: true })
      .then(() => {
        if (seq === baseFinishSeqRef.current) {
          setIsBaseFinish(true);
        }
      })
      .catch(() => {
        if (seq === baseFinishSeqRef.current) {
          setIsBaseFinish(false);
        }
      });
  }, [baseForm]);

  // 获取字典
  const getOptions = async (type: string) => {
    try {
      const res: any = await api.getNewDict(type);
      if (res?.code == 200) {
        return res?.data?.[type] || [];
      } else {
        message.error(res.msg);
        return [];
      }
    } catch (errorInfo: any) {
      message.error(errorInfo?.response?.data?.msg || req_err);
      return [];
    }
  };

  const onChange = (key: string) => {
    setActiveKey(key);
  };

  const renderBtn = (item: string) => {
    const newShowMode =
      detailData.current?.histories?.length > 1 && detailData.current?.histories[0]?.showMode === "AUDIT_UPGRADE";
    switch (item) {
      case "save":
        return (
          <Button type="primary" loading={savaLoading} ghost style={{ marginLeft: "16px" }} onClick={handleSave}>
            {save_text}
          </Button>
        );
      case "submitReview":
        return (
          <Button type="primary" loading={submitLoading} style={{ marginLeft: "16px" }} onClick={submitReview}>
            {release.submit_review}
          </Button>
        );
      case "cancelRelease":
        return (
          <Button type="primary" style={{ marginLeft: "16px" }} onClick={cancelRelease}>
            {release.cancel_release}
          </Button>
        );
      case "down":
        if (newShowMode) {
          break;
        }
        return (
          <Button
            type="primary"
            ghost
            style={{ marginLeft: "16px" }}
            onClick={() => {
              setApplyDownVisible(true);
            }}
          >
            {release.audit_down}
          </Button>
        );
      case "cancelDown":
        return (
          <Button type="primary" style={{ marginLeft: "16px" }} onClick={cancelDown}>
            {release.cancel_down}
          </Button>
        );
      default:
        return;
    }
  };

  const renderTabBar: TabsProps["renderTabBar"] = (props, DefaultTabBar) => (
    <StickyBox offsetTop={0} offsetBottom={20} style={{ zIndex: 99, background: "#fff", paddingTop: 24 }}>
      <DefaultTabBar {...props} />
    </StickyBox>
  );

  // 校验用户名
  const validateName = (_: any, value: any) => {
    if (value) {
      if (value !== detailData.current.name) {
        return api.checkRuleNameApi({ name: value }).then((resp: any) => {
          if (resp.code === 200) {
            if (resp.data?.exist) {
              return Promise.reject(new Error(rules_list.name_already));
            }
          } else {
            return Promise.resolve();
          }
        });
      } else {
        return Promise.resolve();
      }
    } else {
      return Promise.resolve();
    }
  };

  const scrollErrDom = (domClass: string, delayTime?: number) => {
    if (delayTime) {
      delay(() => {
        const errorList = (document as any).querySelectorAll(domClass);
        //由于校验失败ant会自动给失败表单项添加类名，直接获取即可
        errorList[0].scrollIntoView({
          block: "center",
          behavior: "smooth",
        });
      }, delayTime);
    } else {
      const errorList = (document as any).querySelectorAll(domClass);
      //由于校验失败ant会自动给失败表单项添加类名，直接获取即可
      errorList[0].scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    }
  };

  // 处理请求参数
  const handleReq = async (isValidate: boolean) => {
    if (checkIsImgUploading()) {
      message.warning(release.upload_img_ing);
      return;
    } else if (isLoadVersion) {
      message.warning(release.upload_package_query_ing);
      return;
    }

    let baseVal: any;
    if (isValidate) {
      if (activeKey === "1") {
        try {
          baseVal = await baseForm.validateFields();
        } catch (error) {
          scrollErrDom(".ant-form-item-has-error", 100);
          return;
        }
        if (baseVal) {
          try {
            await versionForm.validateFields();
          } catch (error) {
            setActiveKey("2");
            scrollErrDom(".ant-form-item-has-error", 300);
            return;
          }
        }
      } else {
        try {
          baseVal = await baseForm.validateFields();
        } catch (error) {
          setActiveKey("1");
          scrollErrDom(".ant-form-item-has-error", 300);
          return;
        }
        if (baseVal) {
          try {
            await versionForm.validateFields();
          } catch (error) {
            scrollErrDom(".ant-form-item-has-error", 100);
            return;
          }
        }
      }
    }
    if (
      baseFormValues.name == undefined ||
      baseFormValues.name == null ||
      baseFormValues.name == "" ||
      (!(baseFormValues.name == undefined || baseFormValues.name == null || baseFormValues.name == "") &&
        (await validateFormField({ form: baseForm, name: "name" })))
    ) {
      setActiveKey("1");
      resetFormValidate([
        { form: baseForm, formValues: baseFormValues },
        { form: versionForm, formValues: versionFormValues },
      ]);
      baseForm.validateFields(["name"]);
      scrollErrDom(".ant-form-item-has-error", 500);
      return;
    }
    const baseValues = await baseForm.getFieldsValue();
    try {
      const resourcesArr = [];
      const copyrightIds = previewData.map((item: any) => item.id);
      copyrightIds?.length &&
        resourcesArr.push({
          resourceIds: copyrightIds,
          type: "PREVIEW_PICTURE",
        });
      const iconIds = baseValues?.iconResources;
      !!iconIds &&
        resourcesArr.push({
          resourceIds: [iconIds],
          type: "ICON",
        });
      const req = {
        description: baseValues?.description,
        id: id,
        name: baseValues?.name,
        introduction: baseValues?.introduction,
        instanceIds: versionList[0].version ? [versionList[0].id] : [],
        resources: resourcesArr,
        industry: baseValues.industry,
        version: versionList[0].version ? versionList[0].version : "",
      };
      return req;
    } catch (errorInfo: any) {
      console.error(errorInfo);
      return;
    }
  };

  // 校验是否有图片正在上传
  const checkIsImgUploading = () => {
    const previewDataCopy = cloneDeep(previewData);
    const previewChangeLoading = previewDataCopy?.some((item: any) => {
      return item.loading;
    });
    return iconLoading || previewLoading || previewChangeLoading;
  };

  const handleSave = async () => {
    const req = await handleReq(false);
    if (req) {
      try {
        setSavaLoading(true);
        const res: any = await api.saveRuleDataApi(req);
        setSavaLoading(false);
        if (res?.code == 200) {
          getRulesDetail(id);
          message.success(save_success_text);
        } else {
          message.error(res.msg);
        }
      } catch (errorInfo: any) {
        setSavaLoading(false);
        message.error(errorInfo?.response?.data?.msg || req_err);
      }
    }
  };

  // 提交审核
  const submitReview = debounce(async () => {
    const req = await handleReq(true);

    if (req) {
      try {
        setSubmitLoading(true);
        const res: any = await api.saveAuditRuleDataApi(req);
        setSubmitLoading(false);
        if (res?.code == 200) {
          // 接口要区分是否是升级的提交
          const res2: any = await api[detailData.current?.isUpgrade ? "auditUpgradeRuleApi" : "auditReleaseRuleApi"]({
            id: id,
          });
          if (res2?.code == 200) {
            message.success(release.wait_review);
            getRulesDetail(id);
          } else {
            message.error(res2.msg);
          }
        } else {
          message.error(res.msg);
        }
      } catch (errorInfo: any) {
        setSubmitLoading(false);
        message.error(errorInfo?.response?.data?.msg || req_err);
      }
    }
  }, 300);

  const cancelRelease = async () => {
    const modal = Modal.confirm({
      icon: null,
      centered: true,
      closable: true,
      width: 350,
      title: release.cancel_release_title,
      content: release.cancel_release_content,
      footer: (
        <div style={{ textAlign: "right", marginTop: "20px" }}>
          <Button
            type="primary"
            ghost
            onClick={() => {
              modal.destroy();
            }}
          >
            {cancelText}
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: "24px" }}
            loading={cancelReleaseLoading}
            onClick={async () => {
              try {
                setCancelReleaseLoading(true);
                const res: any = await api[
                  detailData.current?.isUpgrade ? "auditCancelUpgradeRuleApi" : "auditCancelReleaseRuleApi"
                ]({ id: id });
                setCancelReleaseLoading(false);
                if (res?.code == 200) {
                  message.success(release.cancel_release_success);
                  getRulesDetail(id);
                  modal.destroy();
                } else {
                  message.error(res.msg);
                }
              } catch (errorInfo: any) {
                setCancelReleaseLoading(false);
                message.error(errorInfo?.response?.data?.msg || req_err);
              }
            }}
          >
            {confirmText}
          </Button>
        </div>
      ),
    });
  };

  const cancelDown = async () => {
    const modal = Modal.confirm({
      icon: null,
      centered: true,
      closable: true,
      width: 350,
      title: release.cancel_down,
      content: release.cancel_down_content,
      footer: (
        <div style={{ textAlign: "right", marginTop: "20px" }}>
          <Button
            type="primary"
            ghost
            onClick={() => {
              modal.destroy();
            }}
          >
            {cancelText}
          </Button>
          <Button
            type="primary"
            loading={cancelDownLoading}
            style={{ marginLeft: "24px" }}
            onClick={async () => {
              try {
                setCancelDownLoading(true);
                const res: any = await api.cancelDownRuleApi({ id: id });
                setCancelDownLoading(false);
                if (res?.code == 200) {
                  message.success(release.cancel_down_success);
                  getRulesDetail(id);
                  modal.destroy();
                } else {
                  message.error(res.msg);
                }
              } catch (errorInfo: any) {
                setCancelDownLoading(false);
                message.error(errorInfo?.response?.data?.msg || req_err);
              }
            }}
          >
            {confirmText}
          </Button>
        </div>
      ),
    });
  };

  const applyDownClose = () => {
    setApplyDownVisible(false);
    getRulesDetail(id);
  };

  // 初始化数据
  const initLoad = async () => {
    const dataCopy = cloneDeep(detailData.current);
    const iconItem = dataCopy?.resources?.find((item: any) => item.type == "ICON");
    const iconPreviewItem = dataCopy?.resources?.filter((item: any) => item.type == "PREVIEW_PICTURE");
    const arrVal = iconPreviewItem.map((item: any) => {
      return {
        id: item.id,
        url: item.url,
        loading: false,
      };
    });
    setPreviewData(arrVal);
    setIconImageUrl(iconItem?.url);
    baseForm.setFieldsValue({
      name: dataCopy?.name || "",
      introduction: dataCopy?.introduction || "",
      description: dataCopy?.description || "",
      iconResources: iconItem?.id || "",
      previewFormData: arrVal,
      industry: dataCopy.industry || [],
    });
    if (dataCopy.appInstances && dataCopy.appInstances.length > 0) {
      setVerSionList(dataCopy.appInstances);
      versionForm.setFieldValue("instanceIds", true);
    } else {
      versionForm.setFieldValue("instanceIds", null);
      setVerSionList([{ createTime: "", version: "", id: "" }]);
    }
    updateBaseFinish();
  };

  // 图片上传前处理
  const beforeUpload: any = (file: RcFile, { width, height, size, accept = ["png"] }: any) => {
    return new Promise<void>((resolve, reject) => {
      const isAccept = accept.some((item: string) => file.type === `image/${item}`);
      const acceptText = accept.join("、").toUpperCase();

      if (!isAccept) {
        message.error(
          `${release.upload_accept_err.text1}${width}${asterisk}${height}${release.upload_accept_err.text2}${acceptText}${release.upload_accept_err.text3}`
        );

        reject();
        return;
      }
      if (size) {
        const imgSize = file.size;
        if (imgSize > size) {
          const sizeText = changeSize(size);
          message.error(`${release.upload_size_err.text1}${sizeText}${release.upload_size_err.text2}`);

          reject();
          return;
        }
      }
      const _URL = window.URL || window.webkitURL;
      const img = new Image();
      img.src = _URL.createObjectURL(file);

      img.onerror = () => {
        message.error(release.upload_fail);
      };
      img.onload = () => {
        if (img.width != width || img.height != height) {
          message.error(
            `${release.upload_accept_err.text1}${width}${asterisk}${height}${release.upload_accept_err.text2}${acceptText}${release.upload_accept_err.text3}`
          );

          reject();
        } else {
          resolve();
        }
      };
    });
  };

  // 图标新增
  const iconImageChange: UploadProps["onChange"] = (info: UploadChangeParam<UploadFile>) => {
    if (info.file.status === "uploading") {
      setIconLoading(true);
      return;
    } else {
      setIconLoading(false);
    }
    if (info.file.status === "done") {
      if (info.file.response.code === 200) {
        const iconUrl = info?.file?.response?.data?.url;
        const iconId = info?.file?.response?.data?.id;

        setIconLoading(false);
        setIconImageUrl(iconUrl);
        baseForm.setFieldValue("iconResources", iconId);
      } else {
        message.error(info.file.response.msg);
      }
    } else {
      baseForm.setFieldValue("iconResources", "");
      setIconImageUrl("");
    }
    baseForm.validateFields(["iconResources"]);
  };
  // 预览图更换
  const previewImgUpdate = (info: UploadChangeParam<UploadFile>, index: number) => {
    const previewDataCopy = cloneDeep(previewData);
    if (info.file.status === "uploading") {
      previewDataCopy[index].loading = true;
      setPreviewData(previewDataCopy);
      return;
    } else {
      previewDataCopy[index].loading = false;
      setPreviewData(previewDataCopy);
    }
    if (info.file.status === "done") {
      if (info.file.response.code === 200) {
        previewDataCopy[index].id = info?.file?.response?.data?.id;
        previewDataCopy[index].url = info?.file?.response?.data?.url;
        previewDataCopy[index].loading = false;
        setPreviewData(previewDataCopy);
      } else {
        message.error(info.file.response.msg);
      }
    } else {
      setPreviewData(previewDataCopy);
    }
    baseForm.validateFields(["previewFormData"]);
  };
  // 预览图删除
  const previewImgDelete = (index: number) => {
    const previewDataCopy = cloneDeep(previewData);
    previewDataCopy.splice(index, 1);
    setPreviewData(previewDataCopy);
    baseForm.validateFields(["previewFormData"]);
  };
  // 预览图新增
  const previewImgChange = (info: UploadChangeParam<UploadFile>) => {
    const previewDataCopy = cloneDeep(previewData);
    if (info.file.status === "uploading") {
      setPreviewLoading(true);
      setPreviewData(previewDataCopy);
      return;
    } else {
      setPreviewLoading(false);
      setPreviewData(previewDataCopy);
    }
    if (info.file.status === "done") {
      if (info.file.response.code === 200) {
        previewDataCopy.push({
          id: info?.file?.response?.data?.id,
          url: info?.file?.response?.data?.url,
          loading: false,
        });
        setPreviewLoading(false);
        setPreviewData(previewDataCopy);
      } else {
        message.error(info.file.response.msg);
      }
    } else {
      setPreviewData(previewDataCopy);
    }
  };

  // 发布版本--重新获取版本信息
  const queryAnewLoad = _.debounce(async () => {
    versionForm.setFieldValue("instanceIds", null);
    try {
      setIsLoadVersion(true);
      const res: any = await api.reloadVersionInfoApi({ id: id, types: ["RULE_ENGINE"] });
      if (res?.code == 200) {
        const endVal = res.data.datas;
        if (endVal.length > 0) {
          setVerSionList(endVal);
          versionForm.setFieldValue("instanceIds", true);
        } else {
          setVerSionList([{ createTime: "", version: "", id: "" }]);
          message.error(`${rules_detail.not_data}`);
        }
      } else {
        message.error(res.msg);
      }
    } catch (errorInfo: any) {
      message.error(errorInfo?.response?.data?.msg || req_err);
    } finally {
      setIsLoadVersion(false);
    }
  }, 600);
  //发布版本--编辑or查看跳转
  const queryJump = () => {
    if (!rulesDetail?.editorUrl) return;
    window.open(`${rulesDetail.editorUrl}`, "_blank");
  };

  const queryIndustryOption = async () => {
    console.log();
    const industryList: any = await getOptions(rules_detail.industry);
    setIndustryOption(industryList);
  };

  useEffect(() => {
    if (rulesDetail) {
      const resData = cloneDeep(rulesDetail);

      const resShowMode = findDeep(release.show_mode_arr, resData?.showMode);

      const nowIndex = resData?.histories.findIndex((item: any) => item.id == resData.id);
      if (nowIndex === 0) {
        //最新版本
        if (resShowMode?.isUpgrade && resData?.histories?.length > 1) {
          // 有升级场景，在新版本页面，按钮要受到旧版本状态影响
          const oldShowMode = resData?.histories[1]?.showMode;
          resData.baseBtns = resShowMode?.btnsByOld[oldShowMode];
        } else {
          resData.baseBtns = resShowMode?.baseBtns;
        }
      } else if (nowIndex === 1) {
        //旧版本
        if (resShowMode?.btnsByNew && resData?.histories?.length > 1) {
          // 有升级场景，在旧版本页面，按钮要受到新版本状态影响
          resData.baseBtns = resShowMode?.btnsByNew[resShowMode];
        } else {
          resData.baseBtns = resShowMode?.baseBtns;
        }
      } else {
        // 历史版本
        resData.baseBtns = resShowMode?.baseBtns;
      }

      resData.showModeLabel = resShowMode?.title;
      resData.isUpgrade = !!resShowMode?.isUpgrade;

      if (resData?.appInstances[0]?.version) {
        resData.showModeLabel = resData?.appInstances[0]?.version + one_bars + resShowMode?.title;
      } else {
        resData.showModeLabel = rules_detail.new_version + one_bars + resShowMode?.title;
      }
      // 当存在两个版本时候，旧版本都不可修改
      if (resData?.histories?.length > 1 && resData?.histories[1]?.id === id) {
        resData.disabled = true;
      } else {
        resData.disabled = resShowMode?.formDisabled;
      }

      resData.packageDisabled =
        resShowMode?.packageDisabled || (resShowMode?.modeObj && resShowMode?.modeObj[resData.mode]?.packageDisabled);
      resData.allowChangePackageList =
        resShowMode?.allowChangePackageList ||
        (resShowMode?.modeObj && resShowMode?.modeObj[resData.mode]?.allowChangePackageList);

      resData.opinion = resShowMode?.opinion;

      resData.titleDescriptionLabel = resShowMode?.titleDescription
        ? resShowMode?.pleaseWrite
          ? resShowMode?.pleaseWrite + rules_detail.detail_title + resShowMode?.titleDescription
          : rules_detail.detail_title + resShowMode?.titleDescription
        : "";

      detailData.current = resData;
      const origin = window.location.origin;
      setIframeUrl(
        `${origin}/sub-app/khlinks/#/khlinks/external/Instance/${resData?.superModelId}?type=superModel&inIframe=true&enable=true`
      );
      initLoad();
    }
  }, [rulesDetail]);
  useEffect(() => {
    updateBaseFinish();
  }, [baseFormValues, updateBaseFinish]);

  useEffect(() => {
    baseForm.setFieldValue("previewFormData", previewData);
  }, [previewData]);
  useEffect(() => {
    getRulesDetail(id);
    iframeUtils.onMessage("login", (data) => {
      console.log("监听iframe页面发送的消息", data);
      goLogin();
    });
  }, [id]);
  useEffect(() => {
    queryIndustryOption();
  }, []);

  return (
    <div className={`appDetail-content ${prefix}`}>
      <div className={`${prefix}-header`}>
        <div className={`${prefix}-header-left`}>
          <div title={detailData.current?.showModeLabel} className="one-line-ellipsis">
            {detailData.current?.showModeLabel}
          </div>
          {detailData.current?.titleDescriptionLabel ? <div>{detailData.current?.titleDescriptionLabel}</div> : null}
          <div className="one-line-ellipsis" title={detailData.current?.opinion || detailData.current?.audit?.content}>
            <span>{release.review_comments}</span>
            {detailData.current?.opinion || detailData.current?.audit?.content || two_bars}
          </div>
        </div>
        <div>
          {detailData.current?.baseBtns?.map((item: string) => {
            return <span key={item}>{renderBtn(item)}</span>;
          })}
        </div>
      </div>
      <div className={`${prefix}-content`}>
        <Tabs
          activeKey={activeKey}
          renderTabBar={renderTabBar}
          indicator={{ size: (origin) => origin - 19, align: "start" }}
          onChange={onChange}
          className={`${prefix}-tabs`}
          items={[
            {
              key: release.tabs[0].key,
              forceRender: true,
              label: (
                <>
                  {release.tabs[0].label}
                  {<CheckCircleFilled style={{ color: isBaseFinish ? "#3EC167" : "#8C8C8C", marginLeft: 4 }} />}
                </>
              ),
              children: (
                <Form
                  disabled={detailData.current?.disabled}
                  form={baseForm}
                  layout="vertical"
                  scrollToFirstError={true}
                  className={`${prefix}-baseForm ${prefix}-form`}
                >
                  <Form.Item
                    label={release.name_label}
                    name="name"
                    validateDebounce={500}
                    rules={[
                      { required: true, message: please_enter + name_label },
                      {
                        pattern: appNameReg,
                        message: rules_detail.name_validator,
                      },
                      {
                        validator: validateName,
                      },
                    ]}
                    getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
                  >
                    <Input
                      placeholder={`${please_enter}${name_label}`}
                      showCount
                      maxLength={30}
                      style={{ width: 524 }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={release.introduction}
                    name="introduction"
                    validateDebounce={500}
                    rules={[{ required: true, message: release.introduction_required }]}
                    getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
                  >
                    <Input
                      placeholder={release.introduction_required}
                      showCount
                      maxLength={30}
                      style={{ width: 524 }}
                    />
                  </Form.Item>

                  <Form.Item
                    label={rules_detail.description_label}
                    name="description"
                    rules={[
                      {
                        required: true,
                        message: `${please_enter}${description_label}`,
                      },
                    ]}
                  >
                    <Input.TextArea
                      placeholder={`${please_enter}${description_label}`}
                      showCount
                      maxLength={500}
                      autoSize={{ minRows: 4, maxRows: 6 }}
                      style={{ width: 524 }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={rules_detail.industry_label}
                    name="industry"
                    rules={[
                      {
                        required: true,
                        message: rules_detail.industry_label_placeholder,
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      showSearch
                      options={industryOption}
                      placeholder={rules_detail.industry_label_placeholder}
                      fieldNames={{ label: "dictLabel", value: "dictCode" }}
                      filterOption={(input, option) =>
                        (option?.dictLabel ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                      style={{ width: 524 }}
                    />
                  </Form.Item>
                  <Form.Item
                    label={release.icon_label}
                    name="iconResources"
                    rules={[{ required: true, message: `${please_upload}${rules_detail.detail_title}${icon_text}` }]}
                    className={`${prefix}-baseForm-iconResources`}
                  >
                    <div>
                      <div className={`${prefix}-form-tip`}>{release.icon_tip}</div>
                      <Upload
                        accept="image/*"
                        listType="picture-card"
                        showUploadList={false}
                        disabled={detailData.current?.disabled || iconLoading}
                        maxCount={1}
                        action={uploadUrl}
                        headers={{
                          Authorization: getAuthTokenValue("Authorization") || "",
                        }}
                        data={{
                          appId: id,
                          type: "ICON",
                          subType: "ICON",
                        }}
                        beforeUpload={async (e) => {
                          await beforeUpload(e, { width: 256, height: 256, size: 3145728, accept: ["png"] });
                        }}
                        onChange={iconImageChange}
                        style={{ margin: 0 }}
                      >
                        {iconImageUrl ? (
                          <img src={iconImageUrl} alt="avatar" />
                        ) : iconLoading ? (
                          <LoadingOutlined />
                        ) : (
                          <PlusSquareFilled className={`${prefix}-add-icon`} />
                        )}
                      </Upload>
                    </div>
                  </Form.Item>
                  <Form.Item
                    name="previewFormData"
                    label={release.preview_screenshot_label}
                    rules={[
                      { required: true, message: release.preview_screenshot_required },
                      ({ getFieldValue }) => ({
                        async validator() {
                          const previewList = getFieldValue("previewFormData");
                          if (previewList.length > 0) {
                            return Promise.resolve();
                          } else {
                            // return Promise.reject(new Error(release.preview_screenshot_validator));
                          }
                        },
                      }),
                    ]}
                  >
                    <div>
                      <div className={`${prefix}-form-tip`}>{release.preview_screenshot_tip}</div>
                      {previewData.map((item, index) => {
                        return (
                          <div key={item.id} className={`${prefix}-upload-img`}>
                            {detailData.current?.disabled ? null : (
                              <CloseCircleFilled
                                className={`${prefix}-upload-img-del`}
                                onClick={() => {
                                  previewImgDelete(index);
                                }}
                              />
                            )}

                            <Upload
                              accept="image/*"
                              listType="picture-card"
                              showUploadList={false}
                              disabled={detailData.current?.disabled || item.loading}
                              maxCount={1}
                              action={uploadUrl}
                              headers={{
                                Authorization: getAuthTokenValue("Authorization") || "",
                              }}
                              data={{
                                appId: id,
                                subType: ["APP", "HAP"],
                                type: "PREVIEW_PICTURE",
                              }}
                              beforeUpload={async (e) => {
                                await beforeUpload(e, {
                                  width: 1800,
                                  height: 920,
                                  size: 3145728,
                                  accept: ["jpg", "jpeg", "png"],
                                });
                              }}
                              onChange={(e) => {
                                previewImgUpdate(e, index);
                              }}
                            >
                              {item.loading ? <LoadingOutlined /> : <img src={item?.url} alt="avatar" />}
                            </Upload>
                          </div>
                        );
                      })}
                      {previewData?.length >= 10 ? null : (
                        <Upload
                          accept="image/*"
                          listType="picture-card"
                          className={`${prefix}-upload-imgAdd`}
                          disabled={detailData.current?.disabled || previewLoading}
                          action={uploadUrl}
                          headers={{
                            Authorization: getAuthTokenValue("Authorization") || "",
                          }}
                          data={{
                            appId: id,
                            subType: ["APP", "HAP"],
                            type: "PREVIEW_PICTURE",
                          }}
                          showUploadList={false}
                          beforeUpload={async (e) => {
                            await beforeUpload(e, {
                              width: 1800,
                              height: 920,
                              size: 3145728,
                              accept: ["jpg", "jpeg", "png"],
                            });
                          }}
                          onChange={(e) => {
                            previewImgChange(e);
                          }}
                        >
                          {previewLoading ? <LoadingOutlined /> : <PlusSquareFilled className={`${prefix}-add-icon`} />}
                        </Upload>
                      )}
                    </div>
                  </Form.Item>
                </Form>
              ),
            },
            {
              key: release.tabs[1].key,
              forceRender: true,
              label: (
                <>
                  {release.tabs[1].label}
                  {
                    <CheckCircleFilled
                      style={{ color: versionList[0].version ? "#3EC167" : "#8C8C8C", marginLeft: 4 }}
                    />
                  }
                </>
              ),
              children: (
                <div style={{ height: "700px" }}>
                  <Form
                    form={versionForm}
                    disabled={detailData.current?.disabled}
                    layout="vertical"
                    scrollToFirstError={true}
                    className={`${prefix}-versionForm ${prefix}-form`}
                  >
                    <Form.Item
                      label={rules_detail.publish_version}
                      name="instanceIds"
                      rules={[{ required: true, message: `${rules_detail.reload_version}` }]}
                      className={`${prefix}-versionForm-packageResources`}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div className={`${prefix}-package-data ${versionList[0].version ? "" : "not-info"}`}>
                          {versionList[0].version && (
                            <div>
                              <p>{versionList[0].version}</p>
                              <p>{format(new Date(Number(versionList[0].createTime)), "yyyy/MM/dd-HH:mm:ss")}</p>
                            </div>
                          )}
                          <div className={`${prefix}-package-data-btn`}>
                            <Button type="primary" style={{ padding: "0 25px" }} onClick={queryJump}>
                              编辑
                            </Button>
                            <Button type="primary" style={{ padding: "0 25px" }} onClick={queryJump}>
                              查看
                            </Button>
                          </div>
                        </div>
                        {detailData.current?.showModeLabel.includes(release.show_mode_arr[0].title) && (
                          <div onClick={queryAnewLoad}>
                            <ReloadOutlined style={{ fontSize: "16px" }} spin={isLoadVersion} />
                          </div>
                        )}
                      </div>
                    </Form.Item>
                  </Form>
                  <div style={{ height: "100%" }}>
                    <span style={{ display: "block", margin: "30px 0 20px 0" }}>
                      <span>{rules_detail.template_name}</span>
                      <Link
                        to={`${publicPath}/super_device_template_detail/info/${detailData.current?.superModelId}`}
                        style={{ color: "#0a59f7" }}
                      >
                        {detailData.current?.superModelName}
                      </Link>
                    </span>
                    <span>调用能力：</span>
                    <iframe
                      src={iframeUrl}
                      style={{ width: "100%", height: "100%", marginBottom: "15px" }}
                      name="login"
                    />
                  </div>
                </div>
              ),
            },
          ]}
        />
      </div>
      <ApplyDown id={id} visible={applyDownVisible} close={applyDownClose} />
    </div>
  );
};

export default VersionManage;
